import { render } from "./HeroiconsOutlinePaperClip.vue?vue&type=template&id=4dc404f7"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePaperClip.vue"]])

export default __exports__